define("shared/models/tiktok-post", ["exports", "@ember/object/computed", "@ember/utils", "@glimmer/tracking", "ember-api-actions", "later/utils/secure-url"], function (_exports, _computed, _utils, _tracking, _emberApiActions, _secureUrl) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3;
  0; //eaimeta@70e063a35619d71f0,"@ember/object/computed",0,"@ember/utils",0,"@glimmer/tracking",0,"ember-api-actions",0,"later/utils/secure-url"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let TiktokPost = _exports.default = (_dec = (0, _computed.alias)('video_description'), _dec2 = (0, _computed.alias)('create_time'), (_class = class TiktokPost {
    /**
     * Constructs an instance a TikTok Post
     *
     * @method constructor
     * @param {Object} obj
     * @param {String} obj.cover_image_url
     * @param {Number} obj.create_time
     * @param {Number} obj.duration
     * @param {Number} obj.expire_time
     * @param {Number} obj.height
     * @param {String} obj.id
     * @param {String} obj.share_url
     * @param {String} obj.video_description
     * @param {Number} obj.width
     *
     * @returns TikTokPost instance
     */

    constructor(data) {
      _initializerDefineProperty(this, "caption", _descriptor, this);
      _initializerDefineProperty(this, "createTime", _descriptor2, this);
      _initializerDefineProperty(this, "linkinbioPost", _descriptor3, this);
      _defineProperty(this, "verify", (0, _emberApiActions.memberAction)({
        path: 'verify',
        type: 'post'
      }));
      Object.entries(data).forEach(_ref => {
        let [key, value] = _ref;
        this[key] = value;
      });
      this.isTiktokPost = true;
    }
    get createdMoment() {
      return moment(this.create_time * 1000);
    }
    get displayTime() {
      return parseInt(this.create_time);
    }
    formatCreatedTime(format) {
      return this.createdMoment.format(format);
    }
    get formattedTimeSinceCreated() {
      return moment(this.formatCreatedTime('ddd, MMM D YYYY LT')).fromNow();
    }
    get hasLinkinbioPost() {
      return !(0, _utils.isEmpty)(this.linkinbioPost);
    }
    get secureStandardResUrl() {
      return (0, _secureUrl.secureUrl)(this.cover_image_url);
    }
    get secureThumbUrl() {
      return (0, _secureUrl.secureUrl)(this.cover_image_url);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "caption", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "createTime", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "linkinbioPost", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  })), _class));
});